import callAPiBase from './base';

const profilesApi = {
  list: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/profileList',
      method: 'GET',
      useToken: true,
      title: 'Profiles - Get List',
      params,
    }),
  get: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/profileList',
      method: 'GET',
      useToken: true,
      title: 'Profiles - Get - Teste',
      params,
    }),
  getCid: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/cidCheck',
      method: 'GET',
      useToken: true,
      title: 'Profiles - Get - CID',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/profileCreate',
      method: 'POST',
      useToken: true,
      title: 'Profile - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/profileUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Profile - Update',
      data,
    }),
  updateOrder: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/profileUpdateOrder',
      method: 'POST',
      useToken: true,
      title: 'Profile - Update order',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/profileDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Profile - Delete',
      params,
    }),
};

export { profilesApi };
export default profilesApi;
